import { Grid, TextField } from "@material-ui/core";
import { Autocomplete, Box, Radio, RadioGroup } from "@mui/material";
import TitleSectionModal from "components/TitleSectionModal";
import { BLANK_VALUE } from "constants/common";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { useTranslation } from "react-i18next";
import ContentNumberColumn from "./ContentNumberColumn";
import SelectFieldTypeDropdown from "./Dropdown";
import Formula from "./Formula";
import SelectCalculate from "./SelectCalculate";
import SelectLabel from "./SelectLabel";
import SelectOptionsNumber, { SelectPosition } from "./SelectOptionsNumber";
import SourceNumberSelect from "./SourceNumberSelect";

const TabNumber = forwardRef(
  (
    {
      defaultPosition = "right",
      defaultFormat = "number",
      defaultDateTimeFormat = 1,
      defaultNumFix = 2,
      listSources,
      setListSources,
      defaultMethod = 1,
      defaultDecimal = 0,
      defaultFormula = "",
      colData,
      helperTextFormula,
      setHelperTextFormula,
      setHelperUseFormula,
      hash = false,
      datetime = false,
    },
    ref
  ) => {
    const convertFormula = () => {
      let res = "";
      let openHash = false;
      for (let i = 0; i < defaultFormula?.length ?? 0; i++) {
        let c = defaultFormula[i];
        if (c === "#") {
          if (!openHash) {
            res += "{{";
            openHash = true;
          } else {
            res += "}}";
            openHash = false;
          }
        } else {
          res += c;
        }
      }
      return res;
    };
    const { t } = useTranslation();
    const [decimal, setDecimal] = useState(defaultNumFix);
    const [labelName, setLabelName] = useState(defaultFormat);
    const [position, setPosition] = useState(defaultPosition);
    const [format, setFormat] = useState(
      ["number", "percent", "vnd", "usd"].includes(defaultFormat)
        ? defaultFormat
        : "other_label"
    );
    const [method, setMethod] = useState(defaultMethod);
    const [formula, setFormula] = useState(convertFormula());
    const [optionsLabelSelect, setOptionsLabelSelect] = useState([]);
    const [dateTimeFormat, setDateTimeFormat] = useState(defaultDateTimeFormat);
    const isHashFormat = hash;

    const isAdditionLabel = format === "other_label";
    console.log(isHashFormat, "isHashFormat");

    useImperativeHandle(ref, () => ({
      _getValue: () => ({
        format: _handleGetFormat(),
        formula: formula.replaceAll("{{", "#").replaceAll("}}", "#"),
        decimal,
        position_format: position === "left" ? 1 : 2,
        isHashFormat: isHashFormat,
        dateTimeFormat,
      }),
    }));
    console.log(format, "format number");
    useEffect(() => {
      if (colData) {
        const selectedSource = colData?.data_from?.calculate_from || [];
        setMethod(colData?.data_from?.calculate_method);
        setDecimal(colData?.decimal);
        setListSources(selectedSource);
        _handleSelectLabel(colData?.format);
      }
    }, [colData]);

    const _handleGetFormat = () => {
      if (format === "percent") return "%";
      if (format === "vnd") return "VND";
      if (format === "usd") return "USD";
      if (format === "number") return "";
      return labelName;
    };

    const _handleSelect = (value) => {
      setDecimal(value);
    };

    const _handleSelectFormat = (value) => {
      setFormat(value);
    };

    const _handleSelectPosition = (value) => {
      setPosition(value);
      setMethod(value);
    };

    const _handleSelectLabel = (value) => {
      setLabelName(value);
    };

    const _handleSelectLabelSelect = (selected) => {
      const listID = [];
      (selected || []).forEach((element) => {
        if (!element.id) return;
        listID.push(element.id);
      });
      setListSources && setListSources(listID);
      setOptionsLabelSelect(selected);
    };

    const _renderLabelNameInput = () => (
      <>
        <TitleSectionModal label={t("LABEL_NAME")} style={{ marginTop: 0 }} />
        <TextField
          placeholder={t("LABEL_NAME")}
          variant="outlined"
          fullWidth
          value={labelName}
          onChange={(e) => setLabelName(e.target.value)}
          InputProps={{
            style: { color: "#666" },
          }}
        />
      </>
    );

    const _renderDemicalNumber = () => (
      <>
        <TitleSectionModal label={t("DECIMAL")} style={{ marginTop: 0 }} />
        <SelectFieldTypeDropdown
          options={[
            { text: 0, type: 0 },
            { text: 1, type: 1 },
            { text: 2, type: 2 },
            { text: 3, type: 3 },
          ]}
          defaultValue={defaultNumFix}
          onSelect={_handleSelect}
        />
      </>
    );

    if (datetime) {
      return (
        <Box sx={{ display: "flex", marginTop: "15px" }}>
          <Radio
            checked={dateTimeFormat === 1}
            onChange={(e) => setDateTimeFormat(1)}
          />{" "}
          <p onCick={(e) => setDateTimeFormat(1)}>
            {t("DATE_AND_TIME_DEFAULT")}
          </p>
          <Radio
            checked={dateTimeFormat === 2}
            onChange={(e) => setDateTimeFormat(2)}
          />
          <p onCick={(e) => setDateTimeFormat(2)}>{t("ONLY_DATE")}</p>
        </Box>
      );
    }

    if (!datetime) {
      return (
        <>
          {isHashFormat && (
            <Grid item xs={12}>
              <TitleSectionModal
                label={t("CREATE_COLUMN_FIELD.FORMULA_COL.FORMULA")}
                style={{ marginTop: 0 }}
              />
              <Formula
                setFormula={setFormula}
                formula={formula}
                setHelperTextFormula={setHelperTextFormula}
                helperTextFormula={helperTextFormula}
                setHelperUseFormula={setHelperUseFormula}
              />
            </Grid>
          )}
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <SelectOptionsNumber
                defaultFormat={
                  ["number", "percent", "vnd", "usd"].includes(defaultFormat)
                    ? defaultFormat
                    : "other_label"
                }
                handleSelectFormat={_handleSelectFormat}
                hash={hash}
              />
              {isAdditionLabel && (
                <Grid item xs={4} pt={0}>
                  {_renderLabelNameInput()}
                </Grid>
              )}
              {format !== "number" && (
                <SelectPosition
                  defaultValue={defaultPosition}
                  handleSelectPosition={_handleSelectPosition}
                />
              )}
              <Grid item xs={4} pt={0}>
                {_renderDemicalNumber()}
              </Grid>
            </Grid>
          </Grid>

          <ContentNumberColumn
            position={position}
            format={format}
            isAdditionLabel={isAdditionLabel}
            labelName={labelName}
            decimal={decimal}
          />
        </>
      );
    }
  }
);

export default TabNumber;
